<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement product active" @click="changeTab('product')">
          <span class="material-icons-sharp"> category </span>Produit
        </div>
        <div class="tabElement fournisseur" @click="changeTab('fournisseur')">
          <span class="material-icons-sharp"> reduce_capacity </span>Fournisseur
        </div>
        <div class="tabElement transitaire" @click="changeTab('transitaire')">
          <span class="material-icons-sharp"> directions_boat </span>
          Transitaire
        </div>
        <div class="tabElement magasin" @click="changeTab('magasin')">
          <span class="material-icons-sharp"> factory </span> Magasin
        </div>
        <div v-if="UserProfile.role != 'Responsable financier'" class="tabElement utilisateur" @click="changeTab('utilisateur')">
          <span class="material-icons-sharp"> manage_accounts </span>
          Utilisateur
        </div>
        <div class="tabElement conteneur" @click="changeTab('conteneur')">
          <span class="material-icons-sharp"> widgets </span>
          Type de conteneur
        </div>
      </div>
      </div>
      <!-- {{ productData }} -->
      <div id="productTab" class="tabElementContent active">
        <div @click="addNewProduct" class="buttonAdd">
          <span> Ajouter un produit</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in productData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'product')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ raccourcirTexte(item.name) }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.unitOfMeasurement }}</td>
                <td>{{ item.unitPrice }}</td>
                <td>{{ raccourcirTexte(item.observation) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="fournisseurTab" class="tabElementContent">
        <div @click="addNewSupplier" class="buttonAdd">
          <span> Ajouter un fournisseur</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableSupplierHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeSupplierRow(item)"
                v-for="item in supplierData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeSupplierRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'supplier')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ raccourcirTexte(item.fullName) }}</td>
                <td>{{ item.phones.join("/") }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.country }}</td>
                <td>{{ item.personContactName }}</td>
                <td>{{ item.personContactPhone }}</td>
                <td>{{ raccourcirTexte(item.observation) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="transitaireTab" class="tabElementContent">
        <div @click="addNewTransitaire" class="buttonAdd">
          <span> Ajouter un Transitaire</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableTransitaireHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeTransitaireRow(item)"
                v-for="item in transitaireData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeTransitaireRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'transitaire')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ raccourcirTexte(item.fullName) }}</td>
                <td>{{ item.phones }}</td>
                <td>{{ item.email }}</td>
                <td>{{ raccourcirTexte(item.observation) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="magasinTab" class="tabElementContent">
        <div @click="addNewStore" class="buttonAdd">
          <span> Ajouter un Magasin</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableStoreHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeStoreRow(item)"
                v-for="item in storeData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeStoreRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'store')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ raccourcirTexte(item.name) }}</td>
                <td>{{ item.address }}</td>
                <td>{{ raccourcirTexte(item.storeResponsible ? item.storeResponsible.fullName : '') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="utilisateurTab" class="tabElementContent">
        <div v-if=" UserProfile.role != 'Responsable des opérations'" @click="addNewUser" class="buttonAdd">
          <span> Ajouter un Utilisateur</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableUserHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="UserProfile.role != 'Responsable des opérations' ? editeUserRow(item) : null "
                v-for="item in userData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeUserRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                         v-if=" UserProfile.role != 'Responsable des opérations'"
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'user')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ item.role }}</td>
                <td>{{ raccourcirTexte(item.fullName) }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.stores.map((item) => item.name).join(" / ") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="conteneurTab" class="tabElementContent">
        <div @click="addNewConteneur" class="buttonAdd">
          <span> Ajouter un Type de conteneur</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable contentListeTableAction">
            <thead>
              <tr>
                <th v-for="item in tableConteneurHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeConteneurRow(item)"
                v-for="item in conteneurData"
                :key="item._id"
              >
              <td>
              <!-- <v-btn class="ml-3" icon>
                <span class="material-icons-sharp"> edit_note </span>
              </v-btn> -->
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <span class="material-icons-sharp">
                      arrow_drop_down_circle
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editeConteneurRow(item)"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        icon
                      >
                        <span class="material-icons-sharp"> edit_note </span>
                      </v-btn>
                    </template>
                    <span>Modification des informations </span>
                  </v-tooltip>
                  <v-tooltip v-if="(UserProfile.role == 'Administrateur')"  bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleterow(item,'conteneur')"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3 mr-3"
                        icon
                         v-if=" UserProfile.role == 'Administrateur'"
                      >
                        <span class="material-icons-sharp"> delete </span>
                      </v-btn>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </td>
                <td>{{ raccourcirTexte(item.name) }}</td>
                <td>{{ raccourcirTexteBig(item.description) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "paramsView",
  components: {},
  data: () => ({
    tableHeader: [
      "",
      "Produit",
      "Type",
      "Unité de mesure",
      "Prix unitaire",
      "Observation",
    ],
    tableSupplierHeader: [
      "",
      "Nom du fournisseur",
      "Téléphones",
      "Mail",
      "Pays",
      "Correspondant",
      "Téléphone correspondant",
      "Observation",
    ],
    tableTransitaireHeader: [
      "",
      "Nom du Transitaire",
      "Téléphones",
      "Mail",
      "Observation",
    ],
    tableConteneurHeader: [
       "","Type de conteneur", "Description"],
    tableStoreHeader: [ "","Nom du Magasin", "Adresse", "Nom du responsable"],
    tableUserHeader: [ "","Role", "Nom complet", "Email", "Magasin"],
    tableData: [],
  }),
  computed: {
    ...mapGetters([
      "productData",
      "supplierData",
      "transitaireData",
      "storeData",
      "userData",
      "conteneurData",
      "UserProfile"
    ]),
  },
  async mounted() {
    this.$emit("show", true);
  console.log("Emitted show true");

  await this.getProduct({});

  console.log("Emitted show false");
  this.$emit("show", false);
  },
  watch: {},
  methods: {
    ...mapActions([
      "getProduct",
      "getSupplier",
      "getTransitaire",
      "getStore",
      
      "getUser",
      "getConteneur",
    ]),
    addNewProduct() {
      this.$emit("show", true);
      const value = {
        modalType: "product",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "product",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    addNewSupplier() {
      this.$emit("show", true);
      const value = {
        modalType: "supplier",
      };
      // alert("ok");
      this.$emit("editeRowForDash", {
        name: "updateSupplier",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    addNewTransitaire() {
      this.$emit("show", true);
      const value = {
        modalType: "transitaire",
      };
      // alert("ok");
      this.$emit("editeRowForDash", {
        name: "updateTransitaire", 
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async addNewStore() {
      this.$emit("show", true);
      const value = {
        modalType: "store",
        latitude: "",
        longitude: "",
      };
      await this.getUser();
      // alert("ok");
      this.$emit("editeRowForDash", {
        name: "store",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async addNewUser() {
      this.$emit("show", true);
      const value = {
        modalType: "user",
        role: "",
      };
      await this.getStore({});
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "user",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    addNewConteneur() {
      this.$emit("show", true);
      const value = {
        modalType: "conteneur",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "conteneur",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    deleterow(item, element) {
      this.$emit("show", true); 
      if (!item.isSelected) {
        for (let i = 0; i < this.productData.length; i++) {
          this.productData[i].isSelected = false;
        }
        item.isSelected = true;
        const value = {
          _id: item._id,
          modalType: "delete",
          elementToDelete: element,
        };
        this.$emit("editeRowForDash", {
          name: "delete",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    editeRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.productData.length; i++) {
          this.productData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.productData);
        const value = {
          _id: item._id,
          modalType: "product",
          name: item.name,
          type: item.type,
          unitOfMeasurement: item.unitOfMeasurement,
          unitPrice: item.unitPrice,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "updateProduct",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    editeSupplierRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.supplierData.length; i++) {
          this.supplierData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.supplierData);
        const value = {
          _id: item._id,
          modalType: "supplier",
          fullName: item.fullName,
          phones: item.phones.join("/"),
          country: item.country,
          email: item.email,
          personContactName: item.personContactName,
          personContactPhone: item.personContactPhone,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "updateSupplier",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    editeTransitaireRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.transitaireData.length; i++) {
          this.transitaireData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.transitaireData);
        const value = {
          _id: item._id,
          modalType: "transitaire",
          fullName: item.fullName,
          phones: item.phones,
          email: item.email,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "updateTransitaire",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeStoreRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.storeData.length; i++) {
          this.storeData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.storeData);
        await this.getUser();
        const value = {
          _id: item._id,
          modalType: "store",
          name: item.name,
          address: item.address,
          phones: item.phone,
          latitude: item.latitude ? item.latitude : '' ,
          longitude: item.longitude ? item.longitude : '' ,
       
          responsible: item.storeResponsible
            ? item.storeResponsible ? item.storeResponsible.fullName : ''
            : "",
        };
        this.$emit("editeRowForDash", {
          name: "updateStore",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeUserRow(item) {
      this.$emit("show", true);

      if (!item.isSelected) {
        for (let i = 0; i < this.userData.length; i++) {
          this.userData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(
          "data send ",
          item.stores.map((item) => item.name).join(",")
        );
        await this.getStore({});
        const value = {
          _id: item._id,
          modalType: "user",
          role: item.role,
          username: item.username,
          stores: item.stores ? item.stores.map((store) => store.name) : "",
          email: item.email,
          jobTitle: item.jobTitle,
          fullName: item.fullName,
        };
        this.$emit("editeRowForDash", {
          name: "updateUser",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    editeConteneurRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.conteneurData.length; i++) {
          this.conteneurData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.conteneurData);
        const value = {
          _id: item._id,
          modalType: "conteneur",
          name: item.name,
          description: item.description,
        };
        this.$emit("editeRowForDash", {
          name: "conteneur",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    generateRandomDate() {
      const year = 2024;
      const month = Math.floor(Math.random() * 12) + 1;
      const day = Math.floor(Math.random() * 28) + 1; // Assuming all months have 28 days
      return `${day}/${month}/${year}`;
    },
    raccourcirTexteBig(texte) {
      //   console.log(texte);
      if (texte) {
        if (texte.length <= 100) {
          return texte;
        } else {
          return texte.slice(0, 100) + "...";
        }
      }
    },
    raccourcirTexte(texte) {
      return texte;
    },
    async changeTab(tabName) {
      this.$emit("show", true);
      this.$emit("closeAllModal");
      if (tabName === "product") {
        await this.getProduct({});
      } else if (tabName === "fournisseur") {
        await this.getSupplier({});
      } else if (tabName === "transitaire") {
        await this.getTransitaire();
      } else if (tabName === "magasin") {
        await this.getStore({});
      } else if (tabName === "utilisateur") {
        await this.getUser();
      } else if (tabName === "conteneur") {
        await this.getConteneur();
      }

      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show", false);
    },
  },
};
</script>
    